import styled, { css } from 'styled-components';


const showInputCss = css`
  & select {
    height: 30px;
    width: 200px;
    max-width: 200px;
    font-size: 0.6em;
  }
`;

const hideInputCss = css`
  & select {
    height: 30px;
    width: 80%;
    max-width: 80%;
    font-size: 0.6em;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background: rgba(0, 0, 0, 0.2);
  color: #000;
  text-transform: none;
  padding: 0px 10px 0px 0px;
  font-size: 0.8em;
  width: 100%;
  ${(props) => (props.showInputCss ? showInputCss : hideInputCss)}
  & select {
    font-size: 1em;
  }
`;

export const Label = styled.label`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1em;
`;

export const FilterButton = styled.button`
  margin-left: 0px;
  margin-top: 0px;
  color: #fff;
  height: 30px;
  width: 30px;
  z-index: 2;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left: none;
  border-top: 1px solid gray;
  border-right: 1px solid gray;
  border-bottom: 1px solid gray;
  background-color: #0095E8;
  padding: 0px;
  :disabled,
  :disabled i {
    cursor: not-allowed;
    background-color: #e7e7e7;
    color: #666;
  }
  &:focus {
    outline: none;
  }
`;

export const InputButtonGroup = styled.div`
  /* display: flex;
  height: 30px;
  margin-bottom: 3px;
  padding: 0px;
  & input {
    width: 95%;
    font-size: 1.3em;
    padding-left: 5px;
    border: 1px solid gray;
    border-right: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    &:focus:-webkit-placeholder {
      color: transparent;
    }
    &:focus {
      outline: none;
    }
  } */
  display: flex;
  height: 30px;
  margin-bottom: 3px;
  padding: 0px;
  & input {
    width: ${(props) => (props.showInput ? '100px' : '0px')};
    font-size: 1em;
    padding-left: 5px;
    border: 1px solid gray;
    border-right: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    &:focus:-webkit-placeholder {
      color: transparent;
    }
    &:focus {
      outline: none;
    }
  }
`;
